import { Engine } from 'engine/Engine';
import { Transform } from '../Transform';
import { Facet } from './Facet';
import { SpriteFacet } from './SpriteFacet';
import { StaticSpriteFacet } from './StaticSpriteFacet';

export interface SpriteGroupFacetProps {
  children: Array<SpriteFacet | StaticSpriteFacet | SpriteGroupFacet>,
  filter?: string,
  transformOrigin?: string,
}

export class SpriteGroupFacet extends Facet<SpriteGroupFacetProps> {
  transform = new Transform();
  start(engine: Engine) {
    this.props.children.forEach(c => c.start(engine));
  }
  update(delta: number, engine: Engine) {
    this.props.children.forEach(c => c.update(delta, engine));
  }
}
